
import { createContext, useContext } from "react";
import type { Member } from "../patents";
import { useSettings } from "src/renewal/interfaces/Settings";
import { PrAnnuityDataProvider } from "./PrAnnuityDataProvider";
import { DmAnnuityFieldsProvider } from "./DmAnnuityFieldsProvider";
import { IpMetaContextProvider } from "src/renewal/patent_renewal/IpMeta";
import { PRIpRightsProvider } from "src/renewal/patent_renewal/IpRights";
import { PRRenewalsProvider } from "src/renewal/patent_renewal/Renewals";
import { useRoles } from "src/user/Auth";

export type AnnuityFields = {
    'renewals-status': (member: Member) => string;
    'last-instruction': (member: Member) => string;
    'fee-due': (member: Member) => string;
    'fees': (member: Member) => Record<string, string>;
    'instruction-due': (member: Member) => string;
    'cost-centers': (member: Member) => string;
};

export const AnnuityFieldsContext = createContext({
  annuityFields: undefined as AnnuityFields | undefined,
  isLoading: false as boolean
})

export function useAnnuityFields() {
  return useContext(AnnuityFieldsContext)
}

// TODO: DATA Providers on top
export function AnnuityFieldsProvider({children}) {
  const { implementation } = useSettings()
  const { hasAnnuities: hasOldDmAnnuities } = useRoles()

  // console.log({implementation, hasOldDmAnnuities})

  if (hasOldDmAnnuities)
      return <DmAnnuityFieldsProvider {...{children}} />

  switch (implementation) {
    case 'dennemeyer':
      // TODO check if we need to add providers here too
      return <DmAnnuityFieldsProvider {...{children}} />
    case 'patent-renewal':
      return (
        <IpMetaContextProvider>
          <PRIpRightsProvider>
            <PRRenewalsProvider states={[]}>
              <PrAnnuityDataProvider {...{ children }} />
            </PRRenewalsProvider>
          </PRIpRightsProvider>
        </IpMetaContextProvider>
      )
   default:
      return children
  }
}
